"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var utils_1 = require("../../../../utils");

var FontAwesome_1 = __importDefault(require("../../../Icon/FontAwesome"));

var Image_1 = __importDefault(require("../../../Icon/Image"));

var constants_1 = __importDefault(require("./constants"));

require("./style.scss");
/**
 * Interactive ID Badge Component
 */


var EmployerBadge = function EmployerBadge(_a) {
  var accentColor = _a.accentColor,
      description = _a.description,
      image = _a.image,
      label = _a.label,
      location = _a.location,
      logo = _a.logo,
      qualifiers = _a.qualifiers,
      textColor = _a.textColor,
      topIconImage = _a.topIconImage,
      website = _a.website;

  var _b = (0, react_1.useState)(320),
      height = _b[0],
      setHeight = _b[1];

  var _c = (0, react_1.useState)(240),
      width = _c[0],
      setWidth = _c[1];

  var _d = (0, react_1.useState)(0),
      mouseX = _d[0],
      setMouseX = _d[1];

  var _e = (0, react_1.useState)(0),
      mouseY = _e[0],
      setMouseY = _e[1];

  var _f = (0, react_1.useState)(undefined),
      mouseLeaveDelay = _f[0],
      setMouseLeaveDelay = _f[1];

  var _g = (0, react_1.useState)(undefined),
      el = _g[0],
      setEl = _g[1];

  var containerDiv = (0, react_1.useRef)(null);
  var mousePX = mouseX / width;
  var mousePY = mouseY / height;
  var tX = mousePX * -6;
  var tY = mousePY * -0.05;
  var rX = mousePX * 3;
  var rY = mousePY * -0.05;
  var cardStyle = {
    transform: "rotateY(" + rX + "deg) rotateX(" + rY + "deg)"
  };
  var bgImage = image || location && location.image;
  var cardBgStyle = bgImage ? {
    backgroundImage: "url(" + bgImage + ")",
    transform: "translateX(" + tX + "px) translateY(" + tY + "px)"
  } : {}; // TODO: Smooth the animation

  (0, react_1.useEffect)(function () {
    if (!containerDiv) return;
    var card = containerDiv.current;
    if (!card) return;
    setEl(card);
    setHeight(card.offsetHeight);
    setWidth(card.offsetWidth);
  });

  var handleMouseMove = function handleMouseMove(e) {
    if (!el) return;

    var _a = (0, utils_1.getOffsetOfElementInViewport)(el),
        left = _a.left,
        top = _a.top;

    setMouseX(e.pageX - left - width / 2);
    setMouseY(e.pageY - top - height / 2);
  };

  var handleMouseEnter = function handleMouseEnter() {
    return clearTimeout(mouseLeaveDelay);
  }; // @ts-ignore


  var handleMouseLeave = function handleMouseLeave() {
    return setMouseLeaveDelay(setTimeout(function () {
      setMouseX(0);
      setMouseY(0);
    }, 300));
  };

  var content = qualifiers && react_1.default.createElement("div", {
    className: "badge-content"
  }, Object.values(qualifiers).map(function (_a) {
    var qualifierLabel = _a.label,
        values = _a.values;
    return react_1.default.createElement("div", {
      className: "badge-content__item",
      key: "badge-qlabel-" + qualifierLabel
    }, react_1.default.createElement("div", {
      className: "badge-content__item__prop"
    }, qualifierLabel + " : "), Object.keys(values).map(function (value) {
      return react_1.default.createElement("div", {
        className: "badge-content__item__value",
        key: "badge-val-" + value
      }, value);
    }));
  }));
  var colorStyle = {
    background: textColor,
    color: accentColor
  };
  var infoPanel = react_1.default.createElement("div", {
    className: "badge-info-panel-container"
  }, react_1.default.createElement("div", {
    className: "badge-info-panel",
    style: colorStyle
  }, react_1.default.createElement("div", {
    className: "badge-info-panel__icon"
  }, react_1.default.createElement(FontAwesome_1.default, {
    name: "FaInfoCircle"
  })), react_1.default.createElement("div", {
    className: "badge-info-panel__body",
    style: colorStyle
  }, react_1.default.createElement("div", {
    className: "employer-info"
  }, react_1.default.createElement("div", {
    className: "badge-info-panel__body__row row-header"
  }, label), react_1.default.createElement(Divider_1.default, {
    style: {
      backgroundColor: accentColor
    }
  }), description && react_1.default.createElement("div", {
    className: "badge-info-panel__body__row"
  }, description), location && location.label && react_1.default.createElement("div", {
    className: "badge-info-panel__body__row"
  }, react_1.default.createElement("span", {
    className: "badge-info-panel__body__row__prop"
  }, "Location:"), location.label, location.image && react_1.default.createElement(Image_1.default, {
    url: location.image
  })), website && react_1.default.createElement("div", {
    className: "badge-info-panel__body__row"
  }, react_1.default.createElement(Button_1.default, {
    className: "employer-info-box__button",
    href: website,
    style: {
      color: accentColor
    },
    target: "_blank"
  }, "Learn More"))))));
  return react_1.default.createElement("div", {
    className: "story-employer-badge-container",
    ref: containerDiv
  }, react_1.default.createElement("div", {
    className: "story-employer-badge",
    style: cardStyle,
    onMouseMove: handleMouseMove,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, react_1.default.createElement("div", {
    className: "badge-graphic-top"
  }, react_1.default.createElement("img", {
    alt: "Badge Graphic",
    src: topIconImage
  })), react_1.default.createElement("div", {
    className: "badge-inner"
  }, infoPanel, react_1.default.createElement("div", {
    className: "badge-inner__bg",
    style: cardBgStyle
  }), react_1.default.createElement("div", {
    className: "badge-body"
  }, logo && react_1.default.createElement("div", {
    className: "badge-logo"
  }, react_1.default.createElement(Image_1.default, {
    url: logo
  })), content))));
};

EmployerBadge.propTypes = {
  /** Determines the foreground color of the info panel. */
  accentColor: prop_types_1.default.string,

  /** Description of the Employer. */
  description: prop_types_1.default.string,

  /** The destination URL of the Employer's image */
  image: prop_types_1.default.string,

  /** The name of the Employer. */
  label: prop_types_1.default.string.isRequired,

  /** Location data of the Employer. */
  location: prop_types_1.default.shape({
    image: prop_types_1.default.string,
    label: prop_types_1.default.string
  }),

  /** The destination URL of the Employer's logo */
  logo: prop_types_1.default.string,

  /** Additional information to render on the `Badge`'s body. */
  // eslint-disable-next-line react/forbid-prop-types
  qualifiers: prop_types_1.default.object,

  /** Determines the background color of the info panel. */
  textColor: prop_types_1.default.string,
  topIconImage: prop_types_1.default.string,
  website: prop_types_1.default.string
};
EmployerBadge.defaultProps = {
  accentColor: '#3d3547',
  description: '',
  image: undefined,
  location: undefined,
  logo: '',
  qualifiers: undefined,
  textColor: '#edeaea',
  topIconImage: constants_1.default,
  website: undefined
};
exports.default = EmployerBadge;